import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as quotationActions from '../Actions/quotationActions';
import * as orderActions from '../Actions/orderActions';
import * as userActions from '../Actions/userActions';
import * as customerActions from '../Actions/customerActions';
import * as languageActions from '../Actions/languageActions';
import QuotationList from "../Components/Quotations/QuotationList";
import { quotationService } from "../Services/QuotationService.js";
import { normalize } from 'normalizr';
import { projectSchema } from '../Schemas/OrderSchema.js';
import { orderService } from "../Services/OrderService.js";

class QuotationListContainer extends Component {
	constructor(props){
		super(props);
		this.fetchProjectRecords = this.fetchProjectRecords.bind(this);
		this.quotationAction = this.quotationAction.bind(this);
		this.deleteProject = this.deleteProject.bind(this);
		this.cercaClient = this.cercaClient.bind(this);
		
	}
	
	componentDidMount() {
		//var orders=orderService.listOrders(this.props.user.access_token);
		quotationService.listQuotations()
					.then(response => {return this.fetchProjectRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	fetchProjectRecords(responseData){
//		console.log("QuotationListContainer:");
//		console.log("responseData:");
//		console.log(responseData);
//		console.log("normalizedData:");
		var normalizedData = normalize(responseData, [projectSchema]);
		
		this.props.actions.fetchQuotationRecords(normalizedData.entities.project);
		this.props.actions.fetchOrderRecords(normalizedData.entities.orders);
		this.props.actions.fetchUserRecords(normalizedData.entities.users);
		this.props.actions.fetchCustomerRecords(normalizedData.entities.customers);
		this.props.actions.fetchLanguagePairs(normalizedData.entities.languagePairs);
		return Object.values(normalizedData.entities.orders).reduce(function(previousValue, currentValue, index, array) {return (array[index].state=='preprocess' ? previousValue+1 : previousValue);}, 0);
	}
	
	quotationAction(projectId, processInstanceId, state){
		var msg="";
		if(state=="quotation_pending"){
			quotationService.acceptQuotation(projectId, true)
						.then(response => { return quotationService.listQuotations()})
						.then(response => {return this.fetchProjectRecords(response.data);})
						.catch(err => {/*console.log(err);*/});
		}
	}
	
	deleteProject(projectId){
		//this.isLoading = true;
		orderService.deleteProject(projectId)
					.then(response => { return quotationService.listQuotations()})
					.then(response => {return this.fetchProjectRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	cercaClient(acum, value){
		if(value){
			if(value.user!==null){
				acum += value.name;
			}
		}
		return acum;
	}
	
	render() {
//		console.log("QuotationListContainer:");
//		console.log(this.props);
		
		let quotF = ((typeof this.props.search !== 'undefined') && (this.props.search.length > 0)) ? (Object.values(this.props.quotationRecords).filter(q => {return (q.name.toUpperCase().includes(this.props.search.toUpperCase()) ||
																									( (typeof this.props.orderRecords[q.orders[0]] != 'undefined') && (typeof this.props.userRecords[this.props.orderRecords[q.orders[0]].user].customer != 'undefined')&& (typeof this.props.userRecords[this.props.customerRecords[this.props.userRecords[this.props.orderRecords[q.orders[0]].user].customer]] != 'undefined') && this.props.customerRecords[this.props.userRecords[this.props.orderRecords[q.orders[0]].user].customer].name.toUpperCase().includes(this.props.search.toUpperCase())) ||
																									q.code.toUpperCase().includes(this.props.search.toUpperCase())  )})) : (this.props.quotationRecords);
		
	    return (<QuotationList	quotations={quotF}
							orders={this.props.orderRecords}
							users={this.props.userRecords}
							customers={this.props.customerRecords}
							langPairs={this.props.langPairs}
							deleteProject = {this.deleteProject}
							quotationActions={this.quotationAction}
							accessToken={this.props.user.access_token}/>);
	}
}

function mapStateToProps(state, ownProps) {  
	return {quotationRecords: state.quotations, orderRecords: state.orders, userRecords: state.users, customerRecords: state.customers, langPairs: state.languagePairs, user: state.user, search: state.search.searchString}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(Object.assign({}, orderActions, quotationActions, userActions, customerActions, languageActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotationListContainer);  